<template>
	<Page :info="info"/>
</template>
<script>
import Page from '../common/Page'
export default {
	components:{Page},
	data(){
		return {
			info:{
				banner:{
					img:'/static/images/scheme/banner2.jpg',
					title:'模具行业风险解决方案',
					subtitle:'我们针对于模具制造行业特性，输出定制如下组合方案，<br>供模具制造生产商基于企业需求进行投保'
				},
				product:[0,1,2,6,4,5],
				case:[0,1,2,4,5]
			}
		}
	},
}
</script>


// WEBPACK FOOTER //
// src/pages/scheme/components/page/Muju.vue